/**
 * FunnelChartWidget - Widget Wrapper
 *
 * Обёртка для FunnelAreaChart с управлением состоянием.
 * Используется на странице Reports.
 */

import React, { useState } from 'react';
import { Card, Title, Group, Text } from '@mantine/core';
import { IconChartAreaLine } from '@tabler/icons-react';
import FunnelAreaChart from '../../Charts/FunnelAreaChart';
import { COOPERATION_STAGES } from '../../../constants/cooperationStages';
import tokens from '../../../theme/designTokens';

const FunnelChartWidget = () => {
  const [period, setPeriod] = useState('month');
  const [granularity, setGranularity] = useState('daily');
  const [visibleStages, setVisibleStages] = useState(
    COOPERATION_STAGES.map((s) => s.code)
  );
  const [showTotal, setShowTotal] = useState(true);

  const handleStageToggle = (stageCode) => {
    setVisibleStages((prev) =>
      prev.includes(stageCode)
        ? prev.filter((s) => s !== stageCode)
        : [...prev, stageCode]
    );
  };

  const handleSelectAll = (selectAll) => {
    if (selectAll) {
      setVisibleStages(COOPERATION_STAGES.map((s) => s.code));
      setShowTotal(true);
    } else {
      setVisibleStages([]);
      setShowTotal(false);
    }
  };

  return (
    <Card
      shadow="sm"
      radius={16}
      withBorder
      p="lg"
      style={{ border: `1px solid ${tokens.colors.neutral[3]}` }}
    >
      {/* Заголовок виджета */}
      <Group gap="sm" mb="md">
        <IconChartAreaLine
          size={24}
          style={{ color: tokens.colors.brand.primary }}
        />
        <div>
          <Title order={4} style={{ color: tokens.colors.neutral[9] }}>
            Динамика воронки
          </Title>
          <Text size="xs" c="dimmed">
            Распределение организаций по этапам сотрудничества
          </Text>
        </div>
      </Group>

      {/* Core Component */}
      <FunnelAreaChart
        period={period}
        granularity={granularity}
        visibleStages={visibleStages}
        showTotal={showTotal}
        onPeriodChange={setPeriod}
        onGranularityChange={setGranularity}
        onStageToggle={handleStageToggle}
        onTotalToggle={() => setShowTotal((prev) => !prev)}
        onSelectAll={handleSelectAll}
        height={350}
      />
    </Card>
  );
};

export default FunnelChartWidget;
